import { onMounted, computed, ref, onUpdated } from 'vue'
import { useStore } from 'vuex'
import StafetRoundCounter from 'components/StafetRoundCounter/StafetRoundCounter.vue'
import StafetRoundCounterAccordion from 'components/StafetRoundCounterAccordion/StafetRoundCounterAccordion.vue'

export default {
    name: 'HoldetsRoundCounterOverlay',
    components: {
        StafetRoundCounter,
        StafetRoundCounterAccordion
    },
    setup() {
        const store = useStore()
        const isSubmitting = computed(() => store.state.stafetRoundCounter.isSubmitting)
        const teamId = computed(() => store.state.main.page_overlay_content_data.teamId)
        const ruter = computed(() => store.state.stafetRoundCounter.ruter)
        const deltagere = computed(() => store.state.stafetRoundCounter.deltagere)
        const maxRegistrationCount = computed(() => store.state.main.page_overlay_content_data.maxRegistrationCount)

        onMounted(() => {
            store.commit('stafetRoundCounter/set_team_id', teamId.value)
            store.dispatch('stafetRoundCounter/getStafetRoundCounter')
        })

        return {
            ruter,
            deltagere,
            isSubmitting,
            maxRegistrationCount,
            getLabel: (labelKey) =>
                store.getters['labels/getLabel']({
                    labelCollection: 'HoldetsRoundCounterOverlay',
                    labelKey
                })
        }
    }
}
